export type CurrencyCode = 'GBP' | 'EUR' | 'USD';

export type CurrencySetting = {
  code: CurrencyCode;
  name: string;
  symbol: string;
};

export const CURRENCIES: CurrencySetting[] = [
  { code: 'GBP', name: 'British Pound', symbol: '£' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'USD', name: 'US Dollar', symbol: '$' },
];

export const DEFAULT_CURRENCY: CurrencySetting = CURRENCIES[0];

export function getCurrencySetting(code?: string | null): CurrencySetting {
  return CURRENCIES.find((currency) => currency.code === code) ?? DEFAULT_CURRENCY;
}

export function parseMoneyValue(value: string | number | null | undefined): number | null {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (!value) return null;
  const parsed = Number.parseFloat(String(value).replace(/[^0-9.]/g, ''));
  return Number.isFinite(parsed) ? parsed : null;
}

export function formatMoney(
  value: string | number | null | undefined,
  currency: Pick<CurrencySetting, 'symbol'> = DEFAULT_CURRENCY,
  options: { from?: boolean; maximumFractionDigits?: number } = {}
) {
  const parsed = parseMoneyValue(value);
  if (parsed === null) return 'Request a quote';

  const maximumFractionDigits = options.maximumFractionDigits ?? 2;
  const minimumFractionDigits = Math.min(parsed % 1 === 0 ? 0 : 2, maximumFractionDigits);

  const formatted = new Intl.NumberFormat('en-GB', {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(parsed);

  return `${options.from ? 'From ' : ''}${currency.symbol}${formatted}`;
}
